import { fmtDate } from "@/lib/constants";

const money = (v) => (v ? `₹${Number(v).toLocaleString("en-IN")}` : "");

const Row = ({ label, value }) => (value ? <div><span className="text-slate-400">{label}: </span><span className="text-slate-700">{value}</span></div> : null);

export const FollowupSummary = ({ rec }) => {
  if (!rec.outlet_call_date && !rec.customer_call_date && !rec.call_attempts && !rec.close_note) return null;
  return (
    <div data-testid="followup-summary" className="space-y-3 rounded-2xl border border-indigo-100 bg-indigo-50/40 p-4 text-sm">
      <h4 className="font-semibold text-slate-800">GRM follow-up</h4>
      {rec.outlet_call_date && (
        <div className="space-y-1">
          <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Outlet call · {fmtDate(rec.outlet_call_date)}</div>
          <Row label="Manager said" value={rec.outlet_manager_summary} />
          <Row label="Outlet action" value={rec.outlet_manager_action} />
        </div>
      )}
      {rec.customer_call_date ? (
        <div className="space-y-1">
          <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Customer call · {fmtDate(rec.customer_call_date)}</div>
          <Row label="Conversation" value={rec.customer_call_summary} />
          <Row label="Action" value={rec.customer_action_taken} />
          <Row label="Compensation" value={[rec.customer_action_type, money(rec.customer_action_amount)].filter(Boolean).join(" · ")} />
        </div>
      ) : rec.call_attempts ? <Row label="Unanswered customer calls" value={String(rec.call_attempts)} /> : null}
      <Row label="Closed by" value={rec.closed_by} />
      <Row label="Note" value={rec.close_note} />
    </div>
  );
};
